<swiper
  [direction]="'vertical'"
  [loop]="true"
  [autoHeight]="true"
  [allowTouchMove]="false"
  [autoplay]="{ delay: 1000, disableOnInteraction: false }"
  [pagination]="false"
  [navigation]="false"
>
  <ng-template data-swiper-autoplay="2500" swiperSlide>
    <div class="d-flex h-100">
      <img src="assets/images/giftools.gif" alt="gif" />
      <h6 class="mb-0 f-w-400">
        <span class="font-primary">10% DESCUENTO! </span
        ><span class="f-light">comprando de contado o transferencia.</span>
      </h6>
      <i class="icon-arrow-top-right f-light"></i>
    </div>
  </ng-template>
  <ng-template data-swiper-autoplay="5000" swiperSlide>
    <div class="d-flex h-100">
      <img src="assets/images/giftools.gif" alt="gif" />
      <h6 class="mb-0 f-w-400">
        <span class="f-light">Quieres un descuento! </span>
      </h6>
      <a
        class="ms-1"
        href="https://wa.me/5493525413350?text=Quiero%20un%20descuento%20por%20favor,%20mi%20nombre%20es%20..."
        target="_blank"
        >¡Escribinos!</a
      >
    </div>
  </ng-template>
</swiper>
